import type * as Stitches from "@stitches/react";
import { styled } from "src/ccl/stitches";

export const Box = styled("div", {
  boxSizing: "border-box",
});

export type BoxProps = Stitches.VariantProps<typeof Box>;
